import React, { useState, useCallback } from "react";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import Modal from "modules/Modal/Modal";
import AddQuestionForm from "./AddQuestionForm";
import QuestionsList from "./QuestionsList";

interface QuestionsModalProps {
  open: boolean;
  onClose: () => void;
}

const QuestionsModal = ({ open, onClose }: QuestionsModalProps) => {
  const [showAddForm, setShowAddForm] = useState(false);

  const handleAddQuestionSuccess = useCallback(() => {
    setShowAddForm(false);
  }, []);

  const handleAddQuestionCancel = useCallback(() => {
    setShowAddForm(false);
  }, []);

  return (
    <Modal
      open={open}
      onClose={onClose}
      styles={{ width: "800px", maxHeight: "80vh", overflow: "auto" }}
    >
      <MDBox p={3}>
        <MDTypography variant="h5" fontWeight="medium" mb={3}>
          Daily Form Inspection Questions
        </MDTypography>

        {!showAddForm && (
          <MDBox display="flex" justifyContent="flex-end" mb={2}>
            <MDButton variant="gradient" color="success" onClick={() => setShowAddForm(true)}>
              Add new question
            </MDButton>
          </MDBox>
        )}

        {showAddForm && (
          <AddQuestionForm
            onCancel={handleAddQuestionCancel}
            onSuccess={handleAddQuestionSuccess}
          />
        )}

        <QuestionsList />

        <MDBox display="flex" justifyContent="flex-end" mt={3}>
          <MDButton variant="outlined" color="secondary" onClick={onClose}>
            Close
          </MDButton>
        </MDBox>
      </MDBox>
    </Modal>
  );
};

export default QuestionsModal;
